<template>
	<div class="personal_center">
		<Header1></Header1>
		<div class="uploadInfo">
			<p class="infotitleStyle">捐赠说明</p>
			<span class="infofontStyle">
				十分感谢您对中国地方志数据库的信任与支持，您提供宝贵的方志资料我们将会妥善保存管理。通过审核归档后的方志将会进入数据库库并向公众开放，届时您就可以在本数据库中查阅到您提供的方志资料。为了方便您的捐赠，我们开通了在线捐赠的入口，您可以在这里填写方志的相关信息、上传电子方志资料，数据库将据此对方志资料进行识别、归档管理。考虑到网页不稳定性与文件过大的可能性，我们也接受通过邮箱捐赠方志。邮箱地址如下：jz@polsci.cn，邮件请注明捐赠方志名称，及您的数据库账号信息：用户名、真实姓名及账号绑定的手机号以方便核对。
			</span>
		</div>
		<div style="text-align: left; margin:17px auto; padding-top: 30px; width: 900px" class="uploadWaper">

			<div class="DiFangZhiHeader">当前位置：<span @click="homePage">首页</span> > <span @click="userCenter">用户中心</span>> 地方志捐赠</div>

			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" v-loading="loading">
				<el-form-item label="册名" prop="volumename">
					<el-input v-model="ruleForm.volumename" placeholder="请输入册名"></el-input>
				</el-form-item>
				<el-form-item label="卷名" prop="rollname">
					<el-input v-model="ruleForm.rollname" placeholder="请输入卷名"></el-input>
				</el-form-item>
				<el-form-item label="选择地区" prop="provinceid">
					<el-select style="width: 100px;" v-model="provinceid" @change="loadCity" size="medium">
						<el-option v-for="item in proviceList" :value="item.areacode" :label="item.areaname" :key="item.areacode"></el-option>
					</el-select>
					<el-select style="width: 100px; margin-left: 10px;" v-model="cityid" @change="loadCountry" size="medium">
						<el-option v-for="item in cityList" :value="item.areacode" :label="item.areaname" :key="item.areacode"></el-option>
					</el-select>
					<el-select style="width: 100px; margin-left: 10px;" v-model="countryid" @change="loadTown" size="medium">
						<el-option v-for="item in countryList" :value="item.areacode" :label="item.areaname" :key="item.areacode"></el-option>
					</el-select>
					<el-select style="width: 100px; margin-left: 10px;" v-model="townid" @change="loadVillage" size="medium">
						<el-option v-for="item in townList" :value="item.areacode" :label="item.areaname" :key="item.areacode"></el-option>
					</el-select>
					<el-select style="width: 100px; margin-left: 10px;" v-model="villageid" @change="setVillage" size="medium">
						<el-option v-for="item in villageList" :value="item.areacode" :label="item.areaname" :key="item.areacode"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="地区编码" prop="areacode" v-show="false">
					<el-input v-model="ruleForm.areacode" :disabled="true" minlength="100px" maxlength="200px" placeholder="请根据地区名称,自动填写地区编码"></el-input>
				</el-form-item>
				<el-form-item label="地区层级" prop="arealevel">
					<el-radio-group v-model="ruleForm.arealevel">
						<el-radio label="全国">全国</el-radio>
						<el-radio label="省">省</el-radio>
						<el-radio label="市">市</el-radio>
						<el-radio label="县">县</el-radio>
						<el-radio label="乡">乡</el-radio>
						<el-radio label="村">村</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年代层级" prop="yearlevel">
					<el-radio-group v-model="ruleForm.yearlevel" @change="loadPeriod">
						<el-radio label="明代及以前">明代及以前</el-radio>
						<el-radio label="清">清</el-radio>
						<el-radio label="民国">民国</el-radio>
						<el-radio label="1949年以后">1949年以后</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年份类型">
					<el-switch v-model="isBC" active-text="年代" inactive-text="公元纪年">
					</el-switch>
				</el-form-item>
				<el-form-item label="成书年份" v-show="isBC" prop="yearlevelone">
					<el-select v-model="yearlevelone" v-show="yearoneshow" @change="loadOneYear">
						<el-option v-for="item in yearOneList" :value="item" :label="item.name" :key="item"></el-option>
					</el-select>
					<el-select v-model="yearleveltwo" v-show="yeartwoshow" @change="loadTwoYear">
						<el-option v-for="item in yearTwoList" :value="item" :label="item" :key="item"></el-option>
					</el-select>
					<span style="margin-left: 15px;color: #a9a9a3;font-style: italic;font-size: 14px;">注：此地方志修著时间</span>
				</el-form-item>
				<el-form-item label="成书年份" v-show="!isBC">
					<el-input v-model="bc" label-width="10px" style="width: 200px;" v-on:blur="getBC" placeholder="请输入公元纪年年份"></el-input>
					<span style="margin-left: 15px;color: #a9a9a3;font-style: italic;font-size: 14px;">注：此地方志修著时间</span>
				</el-form-item>
				<el-dialog title="查询" :visible.sync="dialogVisible" width="30%">
					<h4>您输入的年份{{bc}}</h4>
					<el-radio-group v-model="radio2">
						<el-radio v-for="item in bcList" :label="item.dynasty + item.calendar">{{item.dynasty + item.calendar}}</el-radio>
					</el-radio-group>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="pickYear">确 定</el-button>
					</span>
				</el-dialog>
				<el-form-item label="编撰者">
					<el-input v-model="ruleForm.author" placeholder="请输入编撰者名称"></el-input>
				</el-form-item>
				<el-form-item label="出版单位">
					<el-input v-model="ruleForm.publisher" placeholder="请输入出版单位"></el-input>
				</el-form-item>
				<el-form-item label="旧址">
					<el-input v-model="ruleForm.oldsite" placeholder="请输入旧址"></el-input>
				</el-form-item>
				<!-- <el-form-item label="发布年份" prop="publishyear">
                    <el-date-picker type="year" value-format="yyyy" placeholder="选择发布年份"
                                    v-model="ruleForm.publishyear"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item> -->
				<el-form-item label="发布年份" prop="yearlevel">
					<div style="border: 1px solid #e0e0e0;width: 78%;border-radius: 5px">
						<el-form-item label-width="20px">
							<el-radio-group v-model="yearlevel1" @change="loadPeriod1">
								<el-radio label="明代及以前">明代及以前</el-radio>
								<el-radio label="清">清</el-radio>
								<el-radio label="民国">民国</el-radio>
								<el-radio label="1949年以后">1949年以后</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label-width="20px">
							<el-switch v-model="isBC1" active-text="发布的年代" inactive-text="公元纪年">
							</el-switch>
						</el-form-item>
						<el-form-item v-show="isBC1" label-width="20px">
							<el-select v-model="yearlevelone1" v-show="yearone1show" @change="loadOneYear1">
								<el-option v-for="item in yearOneList1" :value="item" :label="item" :key="item"></el-option>
							</el-select>
							<el-select v-model="yearleveltwo1" v-show="yeartwo1show" @change="loadTwoYear1" label-width="20px">
								<el-option v-for="item in yearTwoList1" :value="item" :label="item" :key="item"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item v-show="!isBC1" label-width="20px">
							<el-input v-model="bc1" v-on:blur="getBC1" placeholder="请输入公元纪年年份" style="width: 80%"></el-input>
						</el-form-item>
						<el-dialog title="查询" :visible.sync="dialogVisible1" width="30%">
							<h4>您输入的发布年份{{bc1}}</h4>
							<el-radio-group v-model="radio21">
								<el-radio v-for="item in bcList1" :label="item.dynasty + item.calendar">{{item.dynasty + item.calendar}}</el-radio>
							</el-radio-group>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible1 = false">取 消</el-button>
								<el-button type="primary" @click="pickYear1">确 定</el-button>
							</span>
						</el-dialog>
					</div>
				</el-form-item>

				<el-form-item label="上传" prop="upload">
					<input type="file" id="file" multiple ref="file" accept=".pdf" @change="uploadFileToFTP" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import {
		request
	} from '../API/ApiUrl.js';
	import {
		Message,
		Loading
	} from "element-ui";
	import Header1 from '../components/Header1.vue';
	import Foot from '../components/Foot.vue';
	export default {
		data() {
			let validateName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入名称'));
				}
				setTimeout(() => {
					if (value.length > 10) {
						callback(new Error('名称不能大于10'));
					} else {
						callback();
					}
				}, 500);
			};
			return {
				files: [],
				natVillageList: [],
				villageList: [],
				townList: [],
				countryList: [],
				cityList: [],
				proviceList: [],
				yearList: [],
				provinceid: '',
				cityid: '',
				countryid: '',
				townid: '',
				villageid: '',
				periodlevel: '',
				isBC: true,
				dynastyList: [],
				dynastyMap: [],
				resultList: [],
				yearlevelone: '',
				yearleveltwo: '',
				yearOneList: [],
				yearTwoList: [],
				bc: '',
				bcList: [],
				dialogVisible: false, //false不现实true显示
				radio2: '',
				yearlevel1: '',
				periodlevel1: '',
				isBC1: false,
				yearlevelone1: '',
				yearleveltwo1: '',
				dialogVisible1: false, //false不现实true显示
				bcList1: [],
				bc1: '',
				radio21: '',
				yearOneList1: [],
				yearTwoList1: [],
				ruleForm: {
					userId: '',
					username: '',
					volumename: '',
					rollname: '',
					areacode: '',
					areaname: '',
					arealevel: '',
					year: '',
					author: '',
					publisher: '',
					yearlevel: '',
					periodlevel1: '',
					oldsite: '',
					publishyear: '',
					purity: '',
					rolltype: '',
					uploadFile: ''
				},
				rules: {
					volumename: [
						// {validator: validateName,message: '请输入册名', trigger: 'blur'},
						{
							required: true,
							message: '请输入册名',
							pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
							trigger: 'blur'
						},

					],
					rollname: [{
						required: true,
						message: '请输入卷名',
						pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
						trigger: 'blur'
					}, ],
					provinceid: [{
						required: true,
						message: '请输入选择地区',
						trigger: 'blur'
					}, ],
					areacode: [{
						required: true,
						message: '请输入地区编码',
						trigger: 'change'
					}, ],
					arealevel: [{
						required: true,
						message: '请输入地区层级',
						trigger: 'change'
					}, ],
					// author: [
					//     {required: true, message: '请输入该字段', trigger: 'change'},
					// ],
					// publisher: [
					//     {required: true, message: '请输入该字段', trigger: 'change'},
					// ],
					yearlevel: [{
						required: true,
						message: '请输入年代层级',
						trigger: 'change'
					}, ],
					yearlevelone: [{
						required: true,
						message: '请输入年代',
						trigger: 'blur'
					}],
					yearleveltwo: [{
						required: true,
						message: '请输入年代',
						trigger: 'blur'
					}],
					periodlevel1: [{
						required: true,
						message: '请选择版本年份',
						trigger: 'blur'
					}],
					purity: [{
						required: true,
						message: '请选择纯净度',
						trigger: 'change'
					}, ],
					rolltype: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}, ],
					upload: [{
						required: true,
						message: '请输入该字段',
						trigger: 'change'
					}, ]
				},
				userInfo: {},
				loading: false,
				yearoneshow: true, //判断选中年代的下拉框是否显示
				yeartwoshow: true,
				yearone1show: true,
				yeartwo1show: true,
				shen: [],
				shi: [],
				xian: [],
				xiang: [],
				cun: [],
			}
		},
		components: {
			Header1,
			Foot
		},
		mounted() {
			this.userInfo = JSON.parse(sessionStorage.getItem('loginData'));
			this.ruleForm.userId = this.userInfo.userId.toString();
			this.ruleForm.username = this.userInfo.username.toString();
			this.loadProvice();
			this.addVisit();
		},
		methods: {
			//增加点击量
			addVisit() {
				request('/apiVisit/addVisitData', {
					module: 101
				}).then(res => {

				})
			},
			homePage() {
				this.$router.push("/index");
			},
			userCenter() {
				this.$router.push("/personal");
			},
			pickYear() {
				this.dialogVisible = false;
				this.bc = this.radio2
				this.ruleForm.year = this.radio2
			},
			pickYear1() {
				this.dialogVisible1 = false;
				this.bc1 = this.radio21
				this.ruleForm.publishyear = this.radio21
			},
			getBC() {
				//判断
				if (this.bc == "") {
					return
				}
				request('/apidfz/parseBC', {
					bc: this.bc
				}).then(res => {
					if (res.code === 200) {
						this.bcList = res.data.dateList
						this.dialogVisible = true;
						this.ruleForm.year = res.data.dateList
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			getBC1() {
				//判断
				if (this.bc1 == "") {
					return
				}
				request('/apidfz/parseBC', {
					bc: this.bc1
				}).then(res => {
					if (res.code === 200) {
						this.bcList1 = res.data.dateList
						this.dialogVisible1 = true;

					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadPeriod() {
				this.periodlevel = this.ruleForm.yearlevel;
				// //console.log(this.ruleForm.yearlevel);
				if (this.ruleForm.yearlevel == "明代及以前") {
					this.yearoneshow = true;
					this.yeartwoshow = true;
					this.yearlevelone = '';
					this.yearleveltwo = '';
				} else if (this.ruleForm.yearlevel == "清") {
					this.yearoneshow = true;
					this.yeartwoshow = true;
					this.yearlevelone = '';
					this.yearleveltwo = '';
				} else if (this.ruleForm.yearlevel == "民国") {
					this.yearoneshow = true;
					this.yeartwoshow = false;
					this.yearlevelone = '';
					this.yearleveltwo = '';
				} else if (this.ruleForm.yearlevel == "1949年以后") {
					this.yearoneshow = true;
					this.yeartwoshow = false;
					this.yearlevelone = '';
					this.yearleveltwo = '';
				}
				this.isBC = true; //年代层级
				// this.ruleForm.yearlevel = "请选择"
				request('/apidfz/getYearLevelDetail', {
					yearLevel: this.periodlevel
				}).then(res => {
					if (res.code === 200) {
						this.yearOneList = res.data.dynastyList
						// //console.log(this.yearOneList)
						this.ruleForm.yearlevelone = ''
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadPeriod1() {
				this.periodlevel1 = this.yearlevel1;
				//console.log(this.periodlevel1);
				this.isBC1 = true; //年代层级

				if (this.yearlevel1 == "明代及以前") {
					this.yearone1show = true;
					this.yeartwo1show = true;
					this.yearlevelone1 = '';
					this.yearleveltwo1 = '';
				} else if (this.yearlevel1 == "清") {
					this.yearone1show = true;
					this.yeartwo1show = true;
					this.yearlevelone1 = '';
					this.yearleveltwo1 = '';
				} else if (this.yearlevel1 == "民国") {
					this.yearone1show = true;
					this.yeartwo1show = false;
					this.yearlevelone1 = '';
					this.yearleveltwo1 = '';
				} else if (this.yearlevel1 == "1949年以后") {
					this.yearone1show = true;
					this.yeartwo1show = false;
					this.yearlevelone1 = '';
					this.yearleveltwo1 = '';
				}
				// this.ruleForm.yearlevel = "请选择"
				request('/apidfz/getYearLevelDetail', {
					yearLevel: this.periodlevel1
				}).then(res => {
					if (res.code === 200) {
						this.yearOneList1 = res.data.dynastyList
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadOneYear1() {
				request('/apidfz/getYearLevelDetail', {
					yearLevel: this.periodlevel1,
					dynasty: this.yearlevelone1
				}).then(res => {
					if (res.code === 200) {
						this.yearTwoList1 = res.data.calendarList
						this.ruleForm.publishyear = this.yearlevelone1;
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadProvice() {
				request('/api/getArea', {
					parentCode: '',
					areaLevel: 1
				}).then(res => {
					if (res.code === 200) {
						this.proviceList = res.data.areaList
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadOneYear() {
				// //console.log(this.periodlevel)
				// //console.log(this.yearlevelone)
				request('/apidfz/getYearLevelDetail', {
					yearLevel: this.periodlevel,
					dynasty: this.yearlevelone
				}).then(res => {
					if (res.code === 200) {
						this.yearTwoList = res.data.calendarList
						this.ruleForm.yearleveltwo = ''
						this.yearleveltwo = '';
						this.ruleForm.year = this.yearlevelone;
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			loadTwoYear() {
				this.ruleForm.year = this.yearleveltwo;
			},
			loadTwoYear1() {
				this.ruleForm.publishyear = this.yearleveltwo1;
			},

			loadCity(item) {
				debugger;
				// this.proviceList.indexOf(this.provinceid)
				this.ruleForm.areacode = this.provinceid;
				this.shen = []
				this.proviceList.forEach(item => {
					if (item.areacode == this.ruleForm.areacode) {
						this.shen.push(item.areaname)
					}
				})

				this.cityid = "";
				this.townid = '';
				this.countryid = '';
				this.villageid = '';
				this.natVillageid = '';

				if (item == "100000000000") {
					this.ruleForm.arealevel = '全国'
					return;
				}
				this.ruleForm.arealevel = '省';

				request('/api/getArea', {
					parentCode: this.provinceid,
					areaLevel: 2
				}).then(res => {
					//console.log(res)
					if (res.code === 200) {
						this.cityList = res.data.areaList
					} else {
						Message(res.data.msg)
					}
				})
			},
			loadCountry() {
				this.ruleForm.arealevel = '市'

				this.ruleForm.areacode = this.cityid;
				this.shi = []
				this.cityList.forEach(item => {
					if (item.areacode == this.ruleForm.areacode) {
						this.shi.push(item.nickname)
					}
				})
				this.countryid = '';
				this.townid = '';
				this.villageid = '';
				this.natVillageid = '';

				request('/api/getArea', {
					parentCode: this.cityid,
					areaLevel: 3
				}).then(res => {
					if (res.code === 200) {
						this.countryList = res.data.areaList
					} else {
						Message(res.data.msg)
					}
				})
			},
			loadTown() {
				this.ruleForm.arealevel = '县'

				this.ruleForm.areacode = this.countryid;
				this.xian = []
				this.countryList.forEach(item => {
					if (item.areacode == this.ruleForm.areacode) {
						this.xian.push(item.areaname)
					}
				})
				this.townid = '';
				this.villageid = '';
				this.natVillageid = '';
				//console.log(this.countryid)
				request('/api/getArea', {
					parentCode: this.countryid,
					areaLevel: 4
				}).then(res => {
					if (res.code === 200) {
						this.townList = res.data.areaList
					} else {
						Message(res.data.msg)
					}
				})
			},
			loadVillage() {
				this.ruleForm.arealevel = '乡'

				this.ruleForm.areacode = this.townid;
				this.xiang = []
				this.townList.forEach(item => {
					if (item.areacode == this.ruleForm.areacode) {
						this.xiang.push(item.areaname)
					}
				})
				this.villageid = '';
				this.natVillageid = '';

				request('/api/getArea', {
					parentCode: this.townid,
					areaLevel: 5
				}).then(res => {
					if (res.code === 200) {
						this.villageList = res.data.areaList
					} else {
						Message(res.data.msg)
					}
				})
			},
			setVillage() {
				this.ruleForm.arealevel = '村'
				this.ruleForm.areacode = this.villageid;
				this.cun = []
				this.villageList.forEach(item => {
					if (item.areacode == this.ruleForm.areacode) {
						this.cun.push(item.areaname)
					}
				})

			},
			submitForm() {
				if (this.ruleForm.volumename == "" ||
					this.ruleForm.rollname == "" ||
					this.provinceid == "" ||
					this.ruleForm.arealevel == "" ||
					this.ruleForm.yearlevel == "" ||
					this.ruleForm.uploadFile == "" ||
					this.ruleForm.yearlevelone1 == "" ||
					this.ruleForm.yearlevel1 == ""

				) {
					alert("请填写必填项内容");
					return false
				}

				this.loading = true;
				let formData = new FormData()
				formData.append('userId', this.ruleForm.userId)
				formData.append('username', this.ruleForm.username)
				formData.append('volumename', this.ruleForm.volumename)
				formData.append('rollname', this.ruleForm.rollname)
				formData.append('areacode', this.ruleForm.areacode)
				// formData.append('areaname', this.ruleForm.areaname)
				formData.append('areaname', this.shen.concat(this.shi.concat(this.xian.concat(this.xiang.concat(this.cun)))).join(
					''))

				formData.append('arealevel', this.ruleForm.arealevel)
				formData.append('year', this.ruleForm.year)
				formData.append('author', this.ruleForm.author)
				formData.append('publisher', this.ruleForm.publisher)
				formData.append('yearlevel', this.ruleForm.yearlevel)
				formData.append('oldsite', this.ruleForm.oldsite)
				formData.append('publishyear', this.ruleForm.publishyear)
				formData.append('purity', this.ruleForm.purity)
				formData.append('pagenumber', this.ruleForm.pagenumber)
				formData.append('sizes', this.ruleForm.sizes)
				formData.append('rolltype', this.ruleForm.rolltype)
				formData.append('uploadFile', this.ruleForm.uploadFile)
				formData.append('yearlevel1', this.ruleForm.yearlevel1)
				formData.append('yearlevelone1', this.yearlevelone1)

				formData.append('donation', 2)
				// formData.append('passflag', -1)
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					dataType: "jsonp"
				}



				//判断大小
				if (!this.checkFileSize(this.ruleForm.sizes)) {
					this.$message.error("文件不能超过30M")
					return false;
				}


				//console.log("=====erererrrrrrrrr")
				this.$http.post('/apidfz/addLcRoll', formData, config).then(res => {
					// //console.log(res)
					if (res.data.code === 200) {
						// //console.log(res);
						this.$message('捐赠成功')
						this.loading = false
						// setTimeout(() => {
						this.$router.replace({
							path: 'personal'
						});
						// }, 500)
						// this.saveFileLog()
					} else {
						this.loading = false
						this.$message({
							message: res.data.msg,
							type: 'error'
						})
					}
				})
			},
			uploadFileToFTP(e) {
				let that = this;
				// let fileType = ['pdf'];
				this.ruleForm.uploadFile = e.target.files[0]
				// //console.log(this.ruleForm.uploadFile.name.indexOf("pdf"))
				if (this.ruleForm.uploadFile.name.indexOf("pdf") < 0) {
					that.$message.error("不支持这种类型的文件")
					return;
				}
				//判断大小
				if (!that.checkFileSize(e.target.files[0].size)) {
					that.$message.error("文件不能超过30M")
					return false;
				}
				// //console.log(this.ruleForm.uploadFile)
				this.ruleForm.sizes = e.target.files[0].size
			},
			formatFileSize: function(fileSize, idx) {
				var units = ["B", "KB", "MB", "GB"];
				idx = idx || 0;
				if (fileSize < 1024 || idx === units.length - 1) {
					return fileSize.toFixed(1) +
						units[idx];
				}
				return this.formatFileSize(fileSize / 1024, ++idx);
			},
			checkFileType: function(fileType) {
				const acceptTypes = ['pdf'];
				for (var i = 0; i < acceptTypes.length; i++) {
					if (fileType === acceptTypes[i]) {
						return true;
					}
				}
				return false;
			},
			checkFileSize: function(fileSize) {
				//30M
				const MAX_SIZE = 30 * 1024 * 1024;
				if (fileSize > MAX_SIZE) {
					return false;
				}
				return true;
			},
			saveFileLog() {
				if (!this.files.name.endsWith('.pdf')) {
					Message.error('请上传PDF格式文件');
					return
				}
				// //console.log(this.files)
				request('api/saveFileLog', {
					fileName: this.files.uuid,
					name: this.files.name
				}).then(res => {
					if (res.code === 200) {
						Message.success('上传成功');
					}
					if (res.code === 500) {
						Message.error(res.msg);
					}
					//console.log(res);
				}).catch(() => {
					Message.error('服务器错误');
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>
<style lang="less" scoped>
	.el-select>.el-input {
		display: block;
		width: 105px;
	}

	.uploadWaper span {
		cursor: pointer;
	}

	.el-form-item {
		margin-bottom: 25px;
	}

	.DiFangZhiHeader {
		padding: 10px 0;
		width: 100%;
		font-size: 12px;
		margin-top: 15px;
		margin-bottom: 29px;
		border-bottom: 1px solid #eee9e9;
		padding-bottom: 21px;
		font-weight: bold;
		color: #1aa98f;
	}

	//级联的外div样式
	.Cascade {
		margin-top: 10px;
	}

	.uploadInfo {
		position: absolute;
		width: 17%;
		z-index: 5;
		margin: 10%;
		border: 1px solid #dbfffa;
		padding: 16px 0px;
		box-shadow: 1px 1px 3px #b4ffea;
	}

	.infotitleStyle {
		font-size: 16px;
		font-weight: bold;
		color: #45ced2;
		text-align: center;
		line-height: 26px;
		margin: 0px;
		width: 100%;
	}

	.infofontStyle {
		font-size: 13px;
		text-indent: 25px;
		padding: 14px;
		letter-spacing: 1px;
		line-height: 25px;
		color: #45ced2;
		font-weight: bold;
	}

	.personal_center {
		min-width: 980px;
		flex-flow: column;

		.DiFangZhiListHeader {
			color: rgba(255, 255, 255, 1);
			height: 180px;
			background-size: 100% 100%;
			background-position: center 0;
			background-size: cover;

			.DiFangZhiListTop {
				display: flex;
				justify-content: space-between;
				padding-top: 55px;
				width: 1200px;
				margin: 0 auto;
				align-items: center;

				.personFlag {
					font-size: 23px;
					display: inline-block;
					margin-left: 10px;
				}

				.Font_size {
					font-size: 16px;
				}
			}
		}

		.personal_info {
			min-height: 500px;
			width: 980px;
			margin: 0 auto;

			.DiFangZhiHeader {
				padding: 10px 0;
				width: 200px;
				// text-align: center;
				font-size: 15px;
			}

			.personalDetail {
				display: flex;
				margin-bottom: 20px;

				.detailLeft {
					width: 250px;
					border: 1px solid #eaeaea;
					border-radius: 3px;
					font-size: 12px;

					.userInfoCtx {
						margin-top: 15px;

						.userImg {
							width: 50px;
							height: 50px;
							overflow: hidden;
							justify-content: center;
							align-items: center;
							display: inline-block;
							vertical-align: middle;
							border-radius: 50%;

							img {
								width: 100%;
							}
						}

						.userInfo {
							display: inline-block;
							vertical-align: middle;
							margin-left: 10px;

							span {
								text-align: left;
							}

							span:nth-child(1) {
								font-size: 14px;
								display: block;
							}

							span:nth-child(2) {
								font-size: 13px;
								color: #c48982;
								display: block;
							}

							span:nth-child(3) {
								color: #5679a2;
								display: block;
								margin-top: 5px;

								span {
									font-size: 12px;
									display: inline-block;
								}
							}
						}
					}

					.personalAction {
						display: flex;
						justify-content: space-between;
						margin-top: 10px;
						margin-left: 15px;
						margin-right: 15px;

						p {
							margin: 4px 0;
						}

						.line {
							width: 1px;
							background: #eaeaea;
						}
					}

					.tabs {
						margin-top: 15px;
						min-height: 150px;
						overflow: auto;

						.personalTab {
							text-align: center;
							padding: 10px 0;
							cursor: pointer;

							&.active {
								background: #d9f1f8;
							}
						}
					}

					.links {
						padding: 30px 15px;
						background: #fafafa;
						height: 300px;
						overflow: auto;

						.linksTitle {
							font-size: 16px;
						}

						.linkItem {
							padding-left: 20px;
							text-align: left;
							margin-top: 25px;
							color: #979797;
						}
					}
				}

				.detailRight {
					font-size: 12px;
					border: 1px solid #eaeaea;
					border-radius: 3px;
					margin-left: 10px;
					flex: 1;
					padding: 0 30px;

					.userActionButton {
						display: flex;
						justify-content: space-between;
						padding: 10px 0;

						.userActionItem {
							display: flex;
							justify-content: center;
							align-items: center;
							width: calc(82px * 1.7);
							height: calc(50px * 1.7);
							font-size: 12px;
							color: #fff;
							border-radius: 5px;

							a>.userActionText {
								padding-left: 5px;
								font-weight: bold;
								font-size: 12px;
								color: #fff;
							}

							.userActionText {
								padding-left: 5px;
								font-weight: bold;
							}
						}

						.difangzhiUpload {
							background: #909cfb;
						}

						.cunqingLuru {
							background: #e49c2d;
						}

						.ziliaoshangchuan {
							background: #be7aff;
						}

						.jicengshangc {
							background: #39bd49;
						}
					}

					.record {
						.title {
							// border-bottom: 0.1px solid #eaeaea;
							margin-top: 10px;
							display: flex;
							justify-content: space-between;

							span:nth-child(1) {
								font-size: 14px;
							}

							span:nth-child(2) {
								color: #979797;
							}
						}

						.userImg {
							width: 40px;
							height: 40px;
							overflow: hidden;
							display: inline-block;
							border-radius: 50%;

							img {
								width: 100%;
							}
						}

						.item {
							// border-bottom: 0px solid #f0f0f0;
							text-align: left;
							padding: 10px;
						}

						.info {
							border-bottom: 2px solid #60abfa;
						}
					}
				}
			}
		}
	}

	.el-input--medium .el-input__inner {
		height: 36px;
		line-height: 36px;
		width: 100px;
	}

	.el-select>.el-input {
		display: block;
		width: 100px;
	}

	el-select {
		width: 100px;
	}
</style>
